<template>
  <div>
      <canvas :id="id"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
    props: ['id', 'labels', 'datasets', 'currency_display'],
    data() {
        return {
            
        }
    },
    mounted() {
        let currencySymbol = this.getCurrencyFormat.currency_symbol
        let currency_display = this.currency_display
        let self = this
        const ctx = document.getElementById(this.id);
        new Chart(ctx, {
            type: "line",
            backgroundColor: 'white',
            data: {
                labels: this.labels,
                datasets: this.datasets
            },
            options: {
                scales: {
                    y: {
                        beginAtZero: false,
                        ticks: {
                            callback: function(value) {
                                return currency_display && self.getCurrencyFormat.show_million ? currencySymbol+' '+self.convertCurrencyToShort(value) : currency_display ? self.formatCurrency(parseFloat(value)) : value.toFixed(2)
                            }
                        }
                    }
                }
            }
        })
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Graphs/Line.vue